var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"btn-link",attrs:{"to":_vm.item.link}},[(_vm.item.icon)?_c('span',{staticClass:"icon"},[_c('img',{attrs:{"src":require(`@/assets/images/icons/${_vm.item.icon}`)}})]):_vm._e(),_vm._v(" "+_vm._s(_vm.item.label)+" ("+_vm._s(_vm.item.count)+" items) ")])
}
var staticRenderFns = []

export { render, staticRenderFns }